import { render, staticRenderFns } from "./address info.vue?vue&type=template&id=6c01542e"
import script from "./address info.vue?vue&type=script&lang=js"
export * from "./address info.vue?vue&type=script&lang=js"
import style0 from "./address info.vue?vue&type=style&index=0&id=6c01542e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports